import React, { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { Loading } from '@twigeducation/ts-fe-components';

export const summaryVersionQuery = gql`
    query summaryVersion($id: String!) {
        summaryVersion(id: $id) {
            id
            title
            slug
            image {
                id
                title
                alt
                cloudinary {
                    publicId
                    versionNumber
                    overlay {
                        color
                        watermark
                    }
                }
            }
            classification {
                mediaType
                contentCategory
            }
        }
    }
`;

const LoadingComponent = () => <Loading />;
const ErrorComponent = () => <div>Error loading asset</div>;
const NoDataComponent = () => <div>No asset data available</div>;

export const useSummaryVersion = (id, options = {}) => {
    const [transformedAsset, setTransformedAsset] = useState(null);

    const { data, loading, error } = useQuery(summaryVersionQuery, {
        variables: { id },
        errorPolicy: 'all',
        ...options,
    });

    useEffect(() => {
        if (data && data.summaryVersion) {
            setTransformedAsset(data.summaryVersion);
        } else if (!loading && !error) {
            setTransformedAsset(null);
        }
    }, [data, loading, error]);

    const hasAsset = !loading && !error && transformedAsset;

    return {
        asset: transformedAsset,
        loading,
        error,
        hasAsset,
        LoadingComponent,
        ErrorComponent,
        NoDataComponent,
    };
};
